var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-wrapper",class:_vm.content.cssClass},[_c('iframe',{attrs:{"src":((_vm.content.heading) + "?shouldAutoFocus=0"),"title":_vm.content.title,"width":"100%","scrolling":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }